import { Director, Publish } from '@millicast/sdk';

import { isProd } from '../../utilities/UrlPaths';

export const RTC_TEST_URL = 'https://rtctest.com';
export const WEB_RTC_TEST_URL = 'https://webrtc.github.io/test-pages/src/audio-and-video/';
export const MILLI_CAST_TEST_URL = 'https://viewer.millicast.com?streamId=yUcuNM';

export const INPUT_DEVICES = {
  CAMERA: 'Camera',
  MICROPHONE: 'Microphone',
  AUDIO_INPUT: 'audioinput',
  VIDEO_INPUT: 'videoinput',
  AUDIO: 'audio',
  VIDEO: 'video'
};

export const checkDeviceSupport = () =>
  new Promise(resolve => {
    if (navigator.mediaDevices?.enumerateDevices) {
      navigator.enumerateDevices = callback =>
        navigator.mediaDevices.enumerateDevices().then(callback);
    }

    if (
      !navigator.enumerateDevices &&
      window.MediaStreamTrack &&
      window.MediaStreamTrack.getSources
    ) {
      navigator.enumerateDevices = window.MediaStreamTrack.getSources.bind(window.MediaStreamTrack);
    }

    if (!navigator.enumerateDevices && navigator.enumerateDevices) {
      navigator.enumerateDevices = navigator.enumerateDevices.bind(navigator);
    }

    const audio = [];
    const video = [];
    const streamSettings = {};

    if (!navigator.enumerateDevices) return;

    navigator.enumerateDevices(devices => {
      devices.forEach(_device => {
        const device = {};

        for (const d in _device) {
          device[d] = _device[d];
        }

        if (!device.deviceId) {
          device.deviceId = device.id;
        }

        if (!device.id) {
          device.id = device.deviceId;
        }

        if (!device.label) {
          if (device.kind === INPUT_DEVICES.AUDIO_INPUT) {
            device.label = INPUT_DEVICES.MICROPHONE;
            device.id = INPUT_DEVICES.MICROPHONE;
          } else if (device.kind === INPUT_DEVICES.VIDEO_INPUT) {
            device.label = INPUT_DEVICES.CAMERA;
            device.id = INPUT_DEVICES.CAMERA;
          } else device.label = "Please check your media's permission.";
          if (window.location.protocol !== 'https:') {
            device.label = `HTTPs is required to get label of this ${device.kind} device.`;
          }
        } else {
          if (
            device.kind === INPUT_DEVICES.VIDEO_INPUT &&
            !streamSettings.isWebcamAlreadyCaptured
          ) {
            streamSettings.isWebcamAlreadyCaptured = true;
          }

          if (
            device.kind === INPUT_DEVICES.AUDIO_INPUT &&
            !streamSettings.isMicrophoneAlreadyCaptured
          ) {
            streamSettings.isMicrophoneAlreadyCaptured = true;
          }
        }

        if (
          (device.kind === INPUT_DEVICES.AUDIO || device.kind === INPUT_DEVICES.AUDIO_INPUT) &&
          !audio.some(({ label }) => device.label === label)
        ) {
          streamSettings.hasMicrophone = true;
          audio.push({ value: device.id, label: device.label });
        }

        if (
          (device.kind === INPUT_DEVICES.VIDEO || device.kind === INPUT_DEVICES.VIDEO_INPUT) &&
          !video.some(({ label }) => device.label === label)
        ) {
          streamSettings.hasWebcam = true;
          video.push({ value: device.id, label: device.label });
        }
      });
      resolve({ streamSettings, audio, video });
    });
  });

export const publishStream = async (
  { token, eventId, audio, video, height = 240, width = 426, replaceTrack },
  callback
) => {
  if (!video || !audio) {
    return;
  }
  try {
    let audioDevice = false;
    let videoDevice = false;
    let audioDeviceId;
    let videoDeviceId;
    if (audio) {
      audioDeviceId = audio !== INPUT_DEVICES.MICROPHONE ? { exact: audio } : undefined;
      audioDevice = { audioDeviceId };
    }
    if (video) {
      videoDeviceId = video !== INPUT_DEVICES.CAMERA ? { exact: video } : undefined;
      videoDevice = {
        videoDeviceId,
        width,
        height
      };
    }
    const mediaConstraints = {
      audio: audioDevice,
      video: videoDevice
    };
    navigator.getUserMedia =
      navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia;
      const mediaStream = await navigator.mediaDevices.getUserMedia({
        audio: true, 
          audioDeviceId, 
        video: true, 
          videoDeviceId,
          width,
          height,
      });

    if (replaceTrack && callback) {
      callback({ mediaStream, error: '' });
    } else {
      const streamAlias = !isProd ? '-stage' : '';
      const tokenGenerator = () =>
        Director.getPublisher({
          token,
          streamName: eventId + streamAlias
        });
      const publisher = new Publish(eventId, tokenGenerator);

      const publishOptions = {
        mediaStream
      };

      if (callback) callback({ mediaStream, publisher, error: '' });

      await publisher.connect(publishOptions);
    }
  } catch (e) {
    let error = '';
    if (typeof e === 'object') {
      error = 'Unable to connect to media, please check permissions.';
    } else error = e.message || e;
    callback({ error, publisher: null });
    console.log(error);
  }
};
